import React from 'react'
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { MenuScreen } from '../UI/MenuScreen';



export const HomeScreen = () => {



    return (

        <div className="home__main">

        <MenuScreen/>

            <div className="home__flex home__section1">
                <div className="home__first">
                    <h1 className="home__title">EMYTO es Escrow my token</h1>
                    <p className="home__description">Te permite garantizar e intercambiar todo tipo de Tokens. Incluso tokens particularmente creados y representativos de bienes.</p>
                </div>

                <div className="home__second2">
                    <Player
                        className="home__lottie"
                        autoplay
                        loop
                        src="./assets/gifts/4180-blockchain-animation.json"
                    >
                    </Player>
                </div>

            </div>
            <div className="home__flex home__section2">


                <div className="home__first2">
                    <Player
                        className="home__lottie"
                        autoplay
                        loop
                        src="./assets/gifts/67171-data-center.json"
                    >
                    </Player>
                </div>

                <div className="home__second2">
                    <h1 className="home__title home__black">
                        ¿Qué es Emyto?</h1>
                    <p className="home__description2 home__black">Emyto es "Escrow My Token". Un sistema disruptivo de depósito en garantía (Escrow); que mantiene inmovilizados los Tokens dentro de un Smart Contract garantizando así el pago o el cumplimiento de una obligación pactada.
                    <br className="mt-5"/> <br/> <br/>  Él se encargará de liberar el pago/Garantía cuando hayas recibido el servicio o producto que compraste y estés satisfecho al 100% con el resultado.
                    <br className="mt-5"/> <br/> <br/>   Utilizando Tecnología Blockchain de la red descentralizada de Ethereum aseguramos que no se puedan manipular transacciones ni alterar el contrato y sus condiciones previamente pactadas.
                    <br className="mt-5"/> <br/> <br/>   ¡Es inviolable y 100% privado! Solo las partes participan, ¡ni siquiera EMYTO!.</p>
                </div>

            </div>

            <div className="home__flex home__section3">


                <div className="home__first2">
                    <Player
                        className="home__lottie"
                        autoplay
                        loop
                        src="./assets/gifts/36021-staking-on-ethereum.json"
                    >
                    </Player>
                </div>

                <div className="home__second2">
                    <h1 className="home__title ">
                        ¿Cómo funciona?</h1>
                    <p className="home__description2 ">El Comprador y vendedor o Garantizante y garantizado, deciden hacer una transacción segura y privada con tecnología Blockchain. <br className="mt-5"/>
                     Acuerdan los términos y se los transmiten al agente de Escrow elegido por las partes para resolver en el supuesto de controversia o desacuerdo.
                     <br className="mt-5"/> Se efectúa el depósito que quedará alojado en el Smart Contract a la espera del cumplimiento de las obligaciones pactadas.
                     <br className="mt-5"/> Resuelto lo pactado en forma positiva o negativa, las partes de común acuerdo pueden liberarse el pago/garantía mutuamente. 
                     <br className="mt-5"/>El Escrow interviene en caso de disputa. En EMYTO podés hacer pagos y todo tipo de transacciones seguras con personas que no conocés.</p>
                </div>

            </div>
        </div>
    )
}
